/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NavigationModule
 */

import { Component } from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';

import {
    POOL_DETAIL_ALERTS,
    POOL_DETAIL_ANALYTICS,
    POOL_DETAIL_EVENTS,
    POOL_DETAIL_HS_INSIGHTS,
    POOL_DETAIL_POOL_LOGS,
    POOL_DETAIL_SERVER,
    POOL_POOL_DETAIL,
} from 'state-names';

import * as globalL10n from 'global-l10n';
import { NavigationService } from '../../services/navigation.service';
import type { ISubheaderNavState } from '../subheader-nav/subheader-nav.component';

const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Subheader component for Pool detail pages.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'pool-subheader',
    template: '<subheader-nav [states]="states"><ng-content></ng-content></subheader-nav>',
})
export class PoolSubheaderComponent {
    public states: ISubheaderNavState[] = [];

    /**
     * Hash of state names to their labels.
     */
    public labelsHash: Record<string, string> = {};

    constructor(
        navigationService: NavigationService,
        l10nService: L10nService,
    ) {
        this.labelsHash = {
            [POOL_DETAIL_ANALYTICS]: l10nService.getMessage(globalL10nKeys.analyticsLabel),
            [POOL_DETAIL_POOL_LOGS]: l10nService.getMessage(globalL10nKeys.logsLabel),
            [POOL_DETAIL_HS_INSIGHTS]: l10nService.getMessage(globalL10nKeys.healthLabel),
            [POOL_DETAIL_SERVER]: l10nService.getMessage(globalL10nKeys.serversLabel),
            [POOL_DETAIL_EVENTS]: l10nService.getMessage(globalL10nKeys.eventsLabel),
            [POOL_DETAIL_ALERTS]: l10nService.getMessage(globalL10nKeys.alertsLabel),
        };

        this.states = navigationService.getChildren(POOL_POOL_DETAIL)
            .map(state => ({
                ...state,
                label: this.labelsHash[state.name],
            }));
    }

    /**
     * Track by function for ngFor iterator on states.
     */
    public trackByState(index: number, state: ISubheaderNavState): string {
        return state.name;
    }
}
